// import React, { useEffect, useState } from "react";
// import {
//   MoreVertical,
//   CirclePlus,
//   Edit2,
//   Trash2,
//   Check,
//   X,
// } from "lucide-react";
// import api from "../../api/axios";

// const HRMSUsers = () => {
//   const [users, setUsers] = useState([]);
//   const [roles, setRoles] = useState([]);

//   const [formData, setFormData] = useState({
//     fullname: "",
//     email: "",
//     password: "",
//     role_id: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!formData.fullname || !formData.email || !formData.password) return;

//     const newUser = {
//       id: users.length + 1,
//       name: formData.fullname,
//       email: formData.email,
//       role: formData.role,
//     };

//     setUsers([...users, newUser]);
//     setFormData({ fullname: "", email: "", password: "", role: "employee" });
//   };

//   const handleRoleChange = (id, newRole) => {
//     const updated = users.map((user) =>
//       user.id === id ? { ...user, role: newRole } : user
//     );
//     setUsers(updated);
//   };

//   const [newRole, setNewRole] = useState("");
//   const [editingRole, setEditingRole] = useState(null);
//   const [editValue, setEditValue] = useState("");

//   // Add new role
//   const handleAddRole = (e) => {
//     e.preventDefault();
//     if (!newRole.trim()) return;

//     const newRoleObj = {
//       id: Date.now(),
//       name: newRole.trim(),
//       permissions: ["read"], // default permission
//     };
//     setRoles([...roles, newRoleObj]);
//     setNewRole("");
//   };

//   // Edit role
//   const handleEdit = (id, name) => {
//     setEditingRole(id);
//     setEditValue(name);
//   };

//   // Save updated role
//   const handleSave = (id) => {
//     setRoles(
//       roles.map((role) =>
//         role.id === id ? { ...role, name: editValue } : role
//       )
//     );
//     setEditingRole(null);
//     setEditValue("");
//   };

//   // Delete role
//   const handleDelete = (id) => {
//     setRoles(roles.filter((role) => role.id !== id));
//   };

//   const [activeTab, setActiveTab] = useState("users");

//   const fetchUsers = async () => {
//     try {
//       const res = await api.get("/users");
//       setUsers(res.data.data || []);
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     }
//   };

//   const fetchRoles = async () => {
//     try {
//       const res = await api.get("/roles");
//       setRoles(res.data.data || []);
//     } catch (error) {
//       console.error("Error fetching roles:", error);
//     }
//   };

//   useEffect(() => {
//     fetchUsers();
//     fetchRoles();
//   }, []);

//   return (
//     <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
//       <div className="row">
//         <div className="col-12">
//           <div className="hrms-users-cont">
//             <div class="d-flex flex-column">
//               <h5 class="fs-4 fw-semibold m-0">User Management</h5>
//               <span class="text-muted fs-6">
//                 A log of all automated emails sent by the system.
//               </span>
//             </div>

//             <div className="hrms-users-tabs-container mt-4">
//               {/* Tabs Header */}
//               <div className="hrms-users-tabs">
//                 <button
//                   className={`hrms-users-tab-btn ${
//                     activeTab === "users" ? "active" : ""
//                   }`}
//                   onClick={() => setActiveTab("users")}
//                 >
//                   Users
//                 </button>

//                 <button
//                   className={`hrms-users-tab-btn ${
//                     activeTab === "roles" ? "active" : ""
//                   }`}
//                   onClick={() => setActiveTab("roles")}
//                 >
//                   Roles
//                 </button>
//               </div>

//               {/* Tabs Content */}
//               <div className="hrms-users-tab-content mt-4">
//                 {activeTab === "users" && (
//                   <div className="hrms-users-tab">
//                     <div className="create-new-users-tab">
//                       <h5 class="fs-4 fw-semibold m-0">Create New User</h5>
//                       <form className="mt-4" onSubmit={handleSubmit}>
//                         <div className="row row-gap-3">
//                           <div className="col-lg-3 col-md-6 col-sm-12">
//                             <label htmlFor="fullname" className="form-label">
//                               Full Name
//                             </label>
//                             <input
//                               type="text"
//                               name="fullname"
//                               value={formData.fullname}
//                               onChange={handleChange}
//                               className="form-control"
//                               placeholder="e.g., John Doe"
//                             />
//                           </div>

//                           <div className="col-lg-3 col-md-6 col-sm-12">
//                             <label htmlFor="email" className="form-label">
//                               Email
//                             </label>
//                             <input
//                               type="email"
//                               name="email"
//                               value={formData.email}
//                               onChange={handleChange}
//                               className="form-control"
//                               placeholder="e.g., john@example.com"
//                             />
//                           </div>

//                           <div className="col-lg-3 col-md-6 col-sm-12">
//                             <label htmlFor="password" className="form-label">
//                               Password
//                             </label>
//                             <input
//                               type="password"
//                               name="password"
//                               value={formData.password}
//                               onChange={handleChange}
//                               className="form-control"
//                               placeholder="Enter password"
//                             />
//                           </div>

//                           <div className="col-lg-3 col-md-6 col-sm-12">
//                             <label htmlFor="role" className="form-label">
//                               Role
//                             </label>
//                             <select
//                               name="role_id"
//                               value={formData.role_id}
//                               onChange={handleChange}
//                               className="form-select"
//                             >
//                               <option value="">Select Role</option>

//                               {roles.map((role) => (
//                                 <option key={role.id} value={role.id}>
//                                   {role.name}
//                                 </option>
//                               ))}
//                             </select>
//                           </div>
//                         </div>
//                         <button
//                           className="btn user-manage-btn d-flex align-items-center gap-2 py-2 px-3 mt-3"
//                           type="submit"
//                         >
//                           <CirclePlus size={18} stroke="#fff" />
//                           Add User
//                         </button>
//                       </form>
//                     </div>

//                     <div className="table-responsive hrms-users-table mt-4">
//                       <table className="table table-hover align-middle">
//                         <thead>
//                           <tr className="border-top">
//                             <th>User</th>
//                             <th>Role</th>
//                             <th style={{ width: "100px" }}>Actions</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {users.map((user) => (
//                             <tr key={user.id}>
//                               <td>
//                                 <div className="d-flex flex-column">
//                                   <span className="fw-semibold">
//                                     {user?.name}
//                                   </span>
//                                   <small className="text-muted">
//                                     {user?.email}
//                                   </small>
//                                 </div>
//                               </td>
//                               <td>
//                                 <select
//                                   className="form-select"
//                                   value={user.role}
//                                   onChange={(e) =>
//                                     handleRoleChange(user.id, e.target.value)
//                                   }
//                                 >
//                                   <option value="admin">Admin</option>
//                                   <option value="hr">HR</option>
//                                   <option value="manager">Manager</option>
//                                   <option value="employee">Employee</option>
//                                 </select>
//                               </td>
//                               <td>
//                                 <div className="dropdown">
//                                   <MoreVertical
//                                     size={16}
//                                     className="dropdown-toggle"
//                                     data-bs-toggle="dropdown"
//                                     aria-expanded="false"
//                                     style={{ cursor: "pointer" }}
//                                   />
//                                   <ul className="dropdown-menu">
//                                     <li>
//                                       <div
//                                         className="dropdown-item"
//                                         style={{ cursor: "pointer" }}
//                                       >
//                                         View Profile
//                                       </div>
//                                     </li>
//                                     <li>
//                                       <div
//                                         className="dropdown-item"
//                                         style={{ cursor: "pointer" }}
//                                       >
//                                         Edit User
//                                       </div>
//                                     </li>
//                                     <li>
//                                       <div
//                                         className="dropdown-item text-danger"
//                                         style={{ cursor: "pointer" }}
//                                       >
//                                         Deactivate User
//                                       </div>
//                                     </li>
//                                   </ul>
//                                 </div>
//                               </td>
//                             </tr>
//                           ))}

//                           {users.length === 0 && (
//                             <tr>
//                               <td
//                                 colSpan="3"
//                                 className="text-center text-muted py-3"
//                               >
//                                 No users found.
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 )}

//                 {activeTab === "roles" && (
//                   <div className="hrms-roles-tab">
//                     <div className="hrms-roles-tab-cont">
//                       <h5 className="fw-semibold">Create New Role</h5>
//                       <form onSubmit={handleAddRole} className="row mt-2 mb-4">
//                         <div className="col-lg-4 col-sm-12 col-12">
//                           <input
//                             type="text"
//                             className="form-control py-2"
//                             placeholder="New role name (e.g., Manager)"
//                             value={newRole}
//                             onChange={(e) => setNewRole(e.target.value)}
//                           />
//                         </div>
//                         <div className="col-lg-2 col-sm-12 col-12">
//                           <button
//                             type="submit"
//                             className="btn user-manage-btn d-flex align-items-center gap-2 py-2 px-3"
//                           >
//                             <CirclePlus size={18} stroke="#fff" />
//                             Add Role
//                           </button>
//                         </div>
//                       </form>

//                       <div className="table-responsive hrms-roles-tab-table">
//                         <table className="table table-hover m-0">
//                           <thead>
//                             <tr className="border-top">
//                               <th>Role</th>
//                               {/* <th>Permissions</th> */}
//                               <th className="text-center">Actions</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {roles.length === 0 ? (
//                               <tr>
//                                 <td
//                                   colSpan={3}
//                                   className="text-center text-muted py-3"
//                                 >
//                                   No roles available.
//                                 </td>
//                               </tr>
//                             ) : (
//                               roles.map((role) => (
//                                 <tr key={role.id}>
//                                   <td>
//                                     {editingRole === role.id ? (
//                                       <input
//                                         type="text"
//                                         className="form-control"
//                                         value={editValue}
//                                         onChange={(e) =>
//                                           setEditValue(e.target.value)
//                                         }
//                                       />
//                                     ) : (
//                                       <span>{role.name}</span>
//                                     )}
//                                   </td>
//                                   {/* <td>
//                                                                         {role.permissions.map((perm, index) => (
//                                                                             <span
//                                                                                 key={index}
//                                                                                 className="badge bg-light text-dark me-1"
//                                                                             >
//                                                                                 {perm}
//                                                                             </span>
//                                                                         ))}
//                                                                     </td> */}
//                                   <td className="text-center">
//                                     {editingRole === role.id ? (
//                                       <div className="d-flex justify-content-center gap-2">
//                                         <button
//                                           type="button"
//                                           className="btn btn-sm btn-success"
//                                           onClick={() => handleSave(role.id)}
//                                         >
//                                           <Check size={16} />
//                                         </button>
//                                         <button
//                                           type="button"
//                                           className="btn btn-sm btn-secondary"
//                                           onClick={() => {
//                                             setEditingRole(null);
//                                             setEditValue("");
//                                           }}
//                                         >
//                                           <X size={16} />
//                                         </button>
//                                       </div>
//                                     ) : (
//                                       <div className="d-flex justify-content-center gap-2">
//                                         <button
//                                           type="button"
//                                           className="btn btn-sm btn-outline-primary"
//                                           onClick={() =>
//                                             handleEdit(role.id, role.name)
//                                           }
//                                         >
//                                           <Edit2 size={16} />
//                                         </button>
//                                         <button
//                                           type="button"
//                                           className="btn btn-sm btn-outline-danger"
//                                           onClick={() => handleDelete(role.id)}
//                                         >
//                                           <Trash2 size={16} />
//                                         </button>
//                                       </div>
//                                     )}
//                                   </td>
//                                 </tr>
//                               ))
//                             )}
//                           </tbody>
//                         </table>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HRMSUsers;

import React, { useEffect, useState } from "react";
import {
  MoreVertical,
  CirclePlus,
  Edit2,
  Trash2,
  Check,
  X,
} from "lucide-react";
import api from "../../api/axios";
import Swal from "sweetalert2";

const HRMSUsers = () => {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loadingUserCreate, setLoadingUserCreate] = useState(false);

  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    password: "",
    role_id: "",
  });

  const [activeTab, setActiveTab] = useState("users");
  const [newRole, setNewRole] = useState("");
  const [editingRole, setEditingRole] = useState(null);
  const [editValue, setEditValue] = useState("");

  // Handle form change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // ============================================
  // 🔥 API: Fetch Users
  // ============================================
  const fetchUsers = async () => {
    try {
      const res = await api.get("/users");
      setUsers(res.data.data || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  // ============================================
  // 🔥 API: Fetch Roles
  // ============================================
  const fetchRoles = async () => {
    try {
      const res = await api.get("/roles");
      setRoles(res.data.data || []);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchRoles();
  }, []);

  // ============================================
  // 🔥 API: Create User
  // ============================================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.fullname || !formData.email || !formData.password) {
      Swal.fire("Missing Data", "Please fill all fields.", "warning");
      return;
    }

    try {
      setLoadingUserCreate(true);
      const payload = {
        name: formData.fullname,
        email: formData.email,
        password: formData.password,
        role_id: formData.role_id,
      };

      const res = await api.post("/users", payload);

      Swal.fire("Success", "User created successfully!", "success");
      fetchUsers();

      setFormData({
        fullname: "",
        email: "",
        password: "",
        role_id: "",
      });
    } catch (err) {
      //   setLoadingUserCreate(false);
      Swal.fire("Error", "Failed to create user", "error");
    } finally {
      setLoadingUserCreate(false);
    }
  };

  // ============================================
  // 🔥 API: Update User Role
  // ============================================
  const handleRoleChange = async (userId, role_id) => {
    try {
      await api.put(`/users/${userId}/role`, { role_id });

      Swal.fire("Updated", "User role updated", "success");
      fetchUsers();
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to update role", "error");
    }
  };

  // ============================================
  // 🔥 API: Add New Role
  // ============================================
  const handleAddRole = async (e) => {
    e.preventDefault();
    if (!newRole.trim()) return;

    try {
      setLoadingUserCreate(true);
      const res = await api.post("/roles", {
        name: newRole,
        slug: newRole
          .toLowerCase()
          .trim()
          .replace(/\s+/g, "-")
          .replace(/[^\w-]+/g, ""),
      });
      Swal.fire("Success", "Role added", "success");

      setNewRole("");
      fetchRoles();
    } catch (error) {
      Swal.fire("Error", "Failed to add role", "error");
    } finally {
      setLoadingUserCreate(false);
    }
  };

  // ============================================
  // 🔥 API: Edit Role
  // ============================================
  const handleSave = async (roleId) => {
    try {
      await api.put(`/roles/${roleId}`, { name: editValue });

      Swal.fire("Updated", "Role updated successfully", "success");
      setEditingRole(null);
      setEditValue("");

      fetchRoles();
    } catch (err) {
      Swal.fire("Error", "Failed to update role", "error");
    }
  };

  // ============================================
  // 🔥 API: Delete Role
  // ============================================
  const handleDelete = async (roleId) => {
    try {
      await api.delete(`/roles/${roleId}`);

      Swal.fire("Deleted", "Role removed successfully", "success");
      fetchRoles();
    } catch (err) {
      Swal.fire("Error", "Cannot delete this role", "error");
    }
  };

  // OPEN EDIT ROLE
  const handleEdit = (id, name) => {
    setEditingRole(id);
    setEditValue(name);
  };

  const getRoleName = (roleId) => {
    const role = roles.find((r) => r.id === roleId);
    return role ? role.name : "Unknown";
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row">
        <div className="col-12">
          <div className="hrms-users-cont">
            {/* -------------------- Tabs -------------------- */}
            <div className="hrms-users-tabs-container mt-4">
              <div className="hrms-users-tabs">
                <button
                  className={`hrms-users-tab-btn ${
                    activeTab === "users" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("users")}
                >
                  Users
                </button>

                <button
                  className={`hrms-users-tab-btn ${
                    activeTab === "roles" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("roles")}
                >
                  Roles
                </button>
              </div>

              <div className="hrms-users-tab-content mt-4">
                {/* -------------------------------------------------------- */}
                {/* USERS TAB */}
                {/* -------------------------------------------------------- */}
                {activeTab === "users" && (
                  <div className="hrms-users-tab">
                    <h5 className="fs-4 fw-semibold m-0">Create New User</h5>

                    <form className="mt-4" onSubmit={handleSubmit}>
                      <div className="row row-gap-3">
                        <div className="col-lg-3">
                          <label className="form-label">Full Name</label>
                          <input
                            type="text"
                            name="fullname"
                            value={formData.fullname}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>

                        <div className="col-lg-3">
                          <label className="form-label">Email</label>
                          <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>

                        <div className="col-lg-3">
                          <label className="form-label">Password</label>
                          <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>

                        <div className="col-lg-3">
                          <label className="form-label">Role</label>
                          <select
                            name="role_id"
                            value={Number(formData.role_id)}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                role_id: Number(e.target.value),
                              })
                            }
                            className="form-select"
                          >
                            <option value="">Select Role</option>
                            {roles.map((role) => (
                              <option key={role.id} value={role.id}>
                                {role.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <button
                        className="btn user-manage-btn d-flex align-items-center gap-2 py-2 px-3 mt-3"
                        type="submit"
                        disabled={loadingUserCreate}
                      >
                        {loadingUserCreate ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Adding...
                          </>
                        ) : (
                          <>
                            <CirclePlus size={18} stroke="#fff" />
                            Add User
                          </>
                        )}
                      </button>
                    </form>

                    {/* Users Table */}
                    <div className="table-responsive hrms-users-table mt-4">
                      <table className="table table-hover align-middle">
                        <thead>
                          <tr className="border-top">
                            <th>User</th>
                            <th>Role</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {users.length > 0 ? (
                            users.map((user) => (
                              <tr key={user.id}>
                                <td>
                                  <strong>{user.name}</strong>
                                  <br />
                                  <small className="text-muted">
                                    {user.email}
                                  </small>
                                </td>
                                <td>
                                  <strong>{getRoleName(user.role_id)}</strong>
                                </td>

                                {/* <td>
                                  <select
                                    className="form-select"
                                    value={user.role_id}
                                    onChange={(e) =>
                                      handleRoleChange(user.id, e.target.value)
                                    }
                                  >
                                    {roles.map((role) => (
                                      <option key={role.id} value={role.id}>
                                        {role.name}
                                      </option>
                                    ))}
                                  </select>
                                </td> */}

                                <td>
                                  <MoreVertical className="dropdown-toggle" />
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center py-3">
                                No users found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {/* -------------------------------------------------------- */}
                {/* ROLES TAB */}
                {/* -------------------------------------------------------- */}
                {activeTab === "roles" && (
                  <div className="hrms-roles-tab">
                    <h5 className="fw-semibold">Create New Role</h5>

                    <form onSubmit={handleAddRole} className="row mt-2 mb-4">
                      <div className="col-lg-4">
                        <input
                          type="text"
                          className="form-control py-2"
                          value={newRole}
                          onChange={(e) => setNewRole(e.target.value)}
                          placeholder="Enter role name"
                        />
                      </div>

                      <div className="col-lg-2">
                        <button
                          className="btn user-manage-btn"
                          type="submit"
                          disabled={loadingUserCreate}
                        >
                          {loadingUserCreate ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Adding...
                            </>
                          ) : (
                            <>
                              <CirclePlus size={18} stroke="#fff" />
                              Add Role
                            </>
                          )}
                        </button>
                      </div>
                    </form>

                    {/* Roles Table */}
                    <table className="table table-hover">
                      <thead>
                        <tr className="border-top">
                          <th>Role</th>
                          <th>Actions</th>
                        </tr>
                      </thead>

                      <tbody>
                        {roles.length > 0 ? (
                          roles.map((role) => (
                            <tr key={role.id}>
                              <td>
                                {editingRole === role.id ? (
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={editValue}
                                    onChange={(e) =>
                                      setEditValue(e.target.value)
                                    }
                                  />
                                ) : (
                                  role.name
                                )}
                              </td>

                              <td className="text-center">
                                {editingRole === role.id ? (
                                  <>
                                    <button
                                      className="btn btn-success btn-sm me-2"
                                      onClick={() => handleSave(role.id)}
                                    >
                                      <Check />
                                    </button>

                                    <button
                                      className="btn btn-secondary btn-sm"
                                      onClick={() => {
                                        setEditingRole(null);
                                        setEditValue("");
                                      }}
                                    >
                                      <X />
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <button
                                      className="btn btn-outline-primary btn-sm me-2"
                                      onClick={() =>
                                        handleEdit(role.id, role.name)
                                      }
                                    >
                                      <Edit2 />
                                    </button>

                                    <button
                                      className="btn btn-outline-danger btn-sm"
                                      onClick={() => handleDelete(role.id)}
                                    >
                                      <Trash2 />
                                    </button>
                                  </>
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={2} className="text-center py-3">
                              No roles available.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HRMSUsers;
